const env = (import.meta as unknown as { env?: { DEV?: boolean } }).env;
const isDevelopment = Boolean(env?.DEV);
const hasConsole = typeof console !== 'undefined';

export function logDebug(...args: unknown[]) {
  if (!hasConsole || !isDevelopment) return;
  // eslint-disable-next-line no-console
  console.debug(...args);
}

export function logInfo(...args: unknown[]) {
  if (!hasConsole) return;
  // eslint-disable-next-line no-console
  console.info(...args);
}

export function logWarn(...args: unknown[]) {
  if (!hasConsole) return;
  // eslint-disable-next-line no-console
  console.warn(...args);
}

export function logError(...args: unknown[]) {
  if (!hasConsole) return;
  // eslint-disable-next-line no-console
  console.error(...args);
}
